import { render, staticRenderFns } from "./PCA.vue?vue&type=template&id=261154be&"
import script from "./PCA.script.js?vue&type=script&lang=js&"
export * from "./PCA.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports